"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  Fieldset: true
};
exports.default = exports.Fieldset = void 0;
var _bind = _interopRequireDefault(require("classnames/bind"));
var _react = _interopRequireDefault(require("react"));
var _constants = require("../utils/constants");
var _AddChildPropsContext = require("../utils/_AddChildPropsContext");
var _Fieldset = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./Fieldset.css") : void 0);
var _Fieldset2 = require("./Fieldset.types");
Object.keys(_Fieldset2).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _Fieldset2[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _Fieldset2[key];
    }
  });
});
var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
const CSS_BLOCK = 'sapcnqr-fieldset';
/**
 * **Fieldset** is used to give semantic meaning to a group of elements
 * inside a form (_e.g._ Billing or Shipping Address).
 * Grouping fields together into a **Fieldset** also provides styling and accessibility benefits.
 */
const Fieldset = exports.Fieldset = /*#__PURE__*/_react.default.forwardRef((props, ref) => {
  const {
      children,
      className,
      disabled,
      formId,
      hideLegend,
      legend,
      legendProps,
      layout
    } = props,
    otherProps = __rest(props, ["children", "className", "disabled", "formId", "hideLegend", "legend", "legendProps", "layout"]);
  const classnames = _bind.default.bind(_Fieldset.default);
  const classes = classnames(className, _constants.CSS_PREFIX, CSS_BLOCK, {
    [`${CSS_BLOCK}--no-legend`]: hideLegend
  });
  const legendClasses = classnames(_constants.CSS_PREFIX, `${CSS_BLOCK}__legend`, legendProps === null || legendProps === void 0 ? void 0 : legendProps.className, {
    [`${CSS_BLOCK}--screen-reader-only`]: hideLegend
  });
  const addChildProps = (child, childProps) => {
    const componentsThatCanBeDisabled = ['Button', 'Checkbox', 'Link', 'Radio', 'Tab'];
    const componentsThatCanBeDisabledAndSupportLayout = ['DatePicker', 'DateInputField', 'DateSelect', 'DateRangeSelect', 'InputField', 'RadioGroup', 'Select', 'TimePicker', 'Slider', 'TextArea'];
    if (componentsThatCanBeDisabled.indexOf(child.displayName) !== -1) {
      return {
        disabled: !!disabled || childProps.disabled,
        layout: layout || (childProps === null || childProps === void 0 ? void 0 : childProps.layout)
      };
    }
    if (componentsThatCanBeDisabledAndSupportLayout.indexOf(child.displayName) !== -1) {
      return {
        disabled: !!disabled || childProps.disabled,
        layout: layout || (childProps === null || childProps === void 0 ? void 0 : childProps.layout)
      };
    }
    return {
      layout: layout || (childProps === null || childProps === void 0 ? void 0 : childProps.layout)
    };
  };
  return /*#__PURE__*/_react.default.createElement("fieldset", Object.assign({}, otherProps, {
    className: classes,
    disabled: disabled,
    form: formId,
    ref: ref
  }), /*#__PURE__*/_react.default.createElement("legend", Object.assign({}, legendProps, {
    className: legendClasses
  }), legend), /*#__PURE__*/_react.default.createElement(_AddChildPropsContext.AddChildPropsProvider, {
    value: addChildProps
  }, children));
});
Fieldset.displayName = 'Fieldset';
var _default = exports.default = Fieldset;